import classNames from 'classnames';

import textClassSwitcher from '../../utils/textClassSwitcher';

import { authorName } from '../Authors.css';
import type { TAuthorAttributes } from '../Authors.type';

interface Props {
  name: string;
  className?: string;
  attributes: TAuthorAttributes;
}

const Name = ({ name, className = '', attributes }: Props) => {
  return (
    <span
      className={classNames(
        authorName,
        'font-semibold',
        textClassSwitcher(className, attributes?.nameFontSize || 'text-lg'),
        attributes?.nameTextTransform || 'normal-case',
      )}
    >
      {name}
    </span>
  );
};
export default Name;
